import React, { useState } from "react";
import "./App.css";

function App() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Subscribed: ${email}`);
    setEmail("");
  };

  return (
    <div className="App">
      <div className="content">
        <div className="text-section">
          <h1 className="logo">nearer</h1>
          <p className="tagline">Coming Soon 👀</p>
          <form onSubmit={handleSubmit} className="form">
            <input
              type="email"
              placeholder="Your email for early access"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>

      <footer className="footer">
        <p>
          © 2025 THE SIXTEENTH DEGREE (PRIVATE) LIMITED. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
